type LabelProps = {
	classes?: {
		label?: string;
	};
	label?: string;
	requiredMark?: boolean;
};

const Label = ({ classes, label, requiredMark }: LabelProps) => {
	return (
		<span className={classes?.label}>
			{label}
			{requiredMark && <span className="text-red-500">{" *"}</span>}
		</span>
	);
};

export default Label;
